export default function Carta({ carta, aDibujos, index2, clicked}: { carta: any; aDibujos:any; index2:any; clicked:any;}) {


    return (
        <div className="carta">

            <div className={"cartaReverso "+(carta.mostrando===1? 'rotado90 ' :'')} onClick={clicked}>
            
                <img className={"icoEstrella "} src="./ico_estrella.png" />
            
            </div>

             <div className={"cartaImg "+(carta.mostrando===0? 'rotado90Ini ' :'')+" "+(carta.mostrando===1? 'desRotado90Ini ' :'')+" "+(carta.solucionado===1? 'acierto ' :'')} onClick={clicked}>
            
                <img className={"imgCarta "} src={"./iconos/"+aDibujos[carta.idDibujo]+".png"}/>
            
            </div>
        </div>

    );



   
  
}